<template>
  <Modal ref="modal" title="Serviços">
    <div class="modal-container">
      <div class="input-row">
        <Input legend="Serviço teórico" :modelValue="servico(1)" :readonly="true" />
        <Input legend="Serviço prático (Carro)" :modelValue="servico(2)" :readonly="true" />
        <Input legend="Serviço prático (Moto)" :modelValue="servico(3)" :readonly="true" />
      </div>
      <div class="input-row">
        <Input legend="Gratuidade teórica" :modelValue="gratuidade(1)" :readonly="true" />
        <Input legend="Gratuidade prática (Carro)" :modelValue="gratuidade(2)" :readonly="true" />
        <Input legend="Gratuidade prática (Moto)" :modelValue="gratuidade(3)" :readonly="true" />
      </div>
    </div>
  </Modal>
</template>

<script>
import utils from '../../services/utils'
import Modal from 'core/Modal'
import Input from 'core/Input'

export default {
  name: 'ServicesModal',
  components: {
    Modal,
    Input,
  },
  data() {
    return {
      utils: utils,
      autoescola: null,
    }
  },
  computed: {

  },
  methods: {
    async open(autoescola) {
      this.autoescola = autoescola

      this.$refs.modal.open()
    },
    gratuidade(type) {
      if (this.autoescola) {
        if (this.autoescola.servicos.find(element => element.servico_id == type)) {
          const inicioGratuidade = this.autoescola.servicos.find(element => element.servico_id == type).inicio_gratuidade
          const fimGratuidade = this.autoescola.servicos.find(element => element.servico_id == type).fim_gratuidade

          if (!inicioGratuidade && !fimGratuidade) {
            return 'Sem gratuidade'
          }
  
          return `${this.utils.formatOnlyDate(inicioGratuidade)} até ${this.utils.formatOnlyDate(fimGratuidade)}`
        }

        return 'Não cadastrada'
      }

      return '-'
    },
    servico(type) {
      if (this.autoescola) {
        const servico = this.autoescola.servicos.find(element => element.servico_id == type)

        if (!servico) {
          return 'Não cadastrado'
        }

        return servico.ativo ? 'Ativo' : 'Inativo'
      }

      return '-'
    },
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .input-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    >div {
      flex: 1;
    }
  }
}
</style>